<template>
  <div id="scheduleItemFullDetails" ref="scheduleItemFullDetails"
    :class="[`playerId-${scheduleItemOrig.scheduleId}`,
      {
        'vertical': scheduleItemOrig.dir === 'vertical',
        'led-preview': scheduleItemOrig._edit.led,
        'led-vertical': scheduleItemOrig._edit.ledVertical
      }]">
    <!-- Schedule/Player Header -->
    <div class="header" :style="{height: `${scheduleItemOrig._edit.scheduleRowHeight}px`}">
      <div :class="['schedule-row-item',
        { 'vertical': scheduleItemOrig.dir === 'vertical' || scheduleItemOrig._edit.ledVertical,
        'led': scheduleItemOrig._edit.led}]"
        :style="{height: `${scheduleItemOrig._edit.scheduleRowHeight}px`}">

        <div class="schedule-preview">
          <div class="preview-card-wrapper grey-background" :style="scheduleItemOrig._edit.previewCardWrapperStyle">
            <div :class="['preview-card']" :style="scheduleItemOrig._edit.previewCardStyle">
              <div class="media-preview-fixed">
                <template v-if="scheduleItemOrig.hasOwnProperty('preview') && scheduleItemOrig.preview !== null">
                  <!-- Image Preview -->
                  <img v-if="scheduleItemOrig.preview.type === 'img'" :src="$utils.filterMediaPreviewUrl(scheduleItemOrig.preview.url)" class="object-fit_cover_center">

                  <!-- Project Preview -->
                  <template v-if="['svg', 'html'].indexOf(scheduleItemOrig.preview.type) >= 0">
                    <iframe :id="`selectedSchedulePreview-${scheduleItemOrig.scheduleId}`"
                      :src="$utils.filterMediaPreviewUrl(scheduleItemOrig.preview.url, { queryParams: { dimensions: scheduleItemOrig.dimensions, dir: scheduleItemOrig.dir } })"
                      :data-src="$utils.trimDataSrc(scheduleItemOrig.preview.url, { queryParams: { dimensions: scheduleItemOrig.dimensions, dir: scheduleItemOrig.dir } })"
                      @load="handleSVGOnLoad()"
                      :class="['object-fit_cover_center', 'template-target-on-refresh-token', `media-preview-${scheduleItemOrig._edit.uid}`]">
                    </iframe>
                  </template>
                </template>
                <template v-else>
                  <div class="no-preview">
                    <div class="np-content">
                      <el-icon class="icon"><PictureFilled /></el-icon>
                      {{$t('label.previewUnavailable')}}
                    </div>
                  </div>
                </template>
              </div>
            </div>

            <div @click.capture="handleScheduleItemClickCapture($event)" class="preview-card-wrapper-cover active-schedule-preview-cover" :style="scheduleItemOrig._edit.previewCardStyle"></div>
            <div v-if="scheduleItemOrig.dir === 'vertical'" class="vertical-left-preview-card-wrapper deny-row-click-capture"></div>
          </div>
        </div>

        <div class="schedule-content" @click.capture="handleScheduleContentClickCapture($event)">
          <!-- Row content background -->
          <div v-if="scheduleItemOrig._isInErrorStatus" class="background-error-status">
            <div :class="scheduleItemOrig._edit.backgroundClassName" class="esg-background"></div>
          </div>
          <div v-else :class="scheduleItemOrig._edit.backgroundClassName" class="background-ok-status"></div>

          <!-- Schedule Name -->
          <div class="schedule-name">
            <div class="schedule-name-txt">{{scheduleItemOrig.name}}</div>
            <template v-if="scheduleItemOrig._isInErrorStatus && scheduleItemOrig._playerStatus === 'disconnected'">
              {{' '}} <span class="player-status">{{$t('label.offline')}}</span>
            </template>
            <template v-else-if="scheduleItemOrig._isInErrorStatus && scheduleItemOrig._playerStatus === 'unconfigured'">
              {{' '}} <span class="player-status">{{$t('label.notConfigured')}}</span>
            </template>

            <div v-if="scheduleItemOrig._isInErrorStatus && scheduleItemOrig._playerStatus === 'unconfigured'"
              @click="handleSetupButtonClick"
              class="setup-not-configured-player"> {{$t('label.setup')}}
            </div>
          </div>

          <!--Timeline-->
          <div class="times time-slider-control-sync">
            <div class="times-content">
              <template v-if="scheduleItemFullDetails !== null">
                <div v-for="(time, indx) in scheduleItemFullDetails.times" :key="indx"
                  :style="time._edit.style"
                  :class="['time-item', {'is-selected': time._edit.isSelected, 'priority-time': time._edit.showPriorityIcon}]"
                  @click="handleScheduleTimeItemClick(time)">
                  <div class="priority-icon"></div>
                  {{time._edit.textLabel}}
                </div>
              </template>
            </div>
          </div>

          <!-- Total Durations -->
          <div v-if="scheduleItemOrig.mediaDurations" class="schedule-media-durations">
            <el-tag
              v-if="scheduleItemOrig.mediaDurations.adds"
              :key="`media-total-durations-adds-${0}`"
              :closable="false"
              :disable-transitions="true"
              :style="{ backgroundColor: '#36425c' }"
              :class="['media-total-durations-adds']">
              <div class="duration-tag-val"><span>{{$utils.formatDurationToMinutesAndSeconds({duration: scheduleItemOrig.mediaDurations.adds})}}</span></div>
            </el-tag>

            <el-tag
              v-if="scheduleItemOrig.mediaDurations.content"
              :key="`media-total-durations-content-${0}`"
              :closable="false"
              :disable-transitions="true"
              :style="{'backgroundColor': 'rgba(255, 0, 0, 0)'}"
              :class="['media-total-durations-content']">
              <div class="duration-tag-val"><span>{{$utils.formatDurationToMinutesAndSeconds({duration: scheduleItemOrig.mediaDurations.content})}}</span></div>
            </el-tag>
          </div>
        </div>
      </div>
    </div>

    <div class="media-content hide-scrollbar">
      <!-- Smart Adds -->
      <template v-if="scheduleItemFullDetails && scheduleItemFullDetails.addsEvents && enableSmartAdds">
        <div id="smartAddsScheduleSortGroupWrapper">
          <draggable
            v-bind="sortDraggableAddsEvents"
            v-model="scheduleItemFullDetails.addsEvents"
            id="smartAddsSortGroup"
            group="smart-adds-schedule-sort"
            :item-key="(element) => element?._edit?.sortKeyWithIndx"
            :component-data="{name:'flip-list'}"
            :disabled="!enableEditCalendar || lockDraggableSortableEventRow === 'smartAddsScheduleSortable'"
            :class="['media-events-sortable-group', {'disabled': !enableEditCalendar}]"
            :forceFallback="true"
            :move="handleMediaEventSortMove"
            @clone="handleMediaEventSortClone({smartAdds: true})"
            @start="handleMediaEventSortStart({smartAdds: true})"
            @end="handleMediaEventSortEnd">
            <template #item="{ element: event, index: indx }">
              <div
                :class="['media-row-item', 'select-none', 'sortable-el', 'list-group-item', 'smart-adds-schedule-row', `eventUid${event.uid}`,
                {'media-uploading': event._edit && (event._edit.optimisticUpdate && !event._edit.optimisticUpdate.uploadFinished),
                'media-sorting': event._edit && (event._edit.optimisticUpdate && !event._edit.optimisticUpdate.uploadFinished),
                'is-selected': (event._edit.isSelected),
                'is-row-selected': (event._edit.isRowSelected),
                'is-sort-drag': mediaEventSortDragTriggered.start,
                'mouseover': (mouseoverMediaItemClass === `eventUid${event.uid}`),
                'disabled-mouseover': (disableMouseoverClass === `eventUid${event.uid}`),
                'has-pop-identifer': (event._edit.popId && showPopIds)}]"
                @mouseover="handleMediaRowMouseHoverAndMouseOut('mouseover', $event)"
                @mouseout="handleMediaRowMouseHoverAndMouseOut('mouseout', $event)">

                <!--Schedule Details -->
                <div :class="['media-details']">
                  <div class="media-preview-wrapper grey-background">
                    <div class="media-preview" :style="{backgroundColor: event._edit.mediaRowBackgroundColorFade, ...scheduleItemOrig._edit.mediaPreviewCardStyle}">
                      <template v-if="event._edit.media.hasOwnProperty('preview') && event._edit.media.preview !== null">
                        <!-- Image Preview -->
                        <img v-if="event._edit.media.preview.type === 'img'"
                          :src="$utils.filterMediaPreviewUrl(event._edit.media.preview.url)"
                          class="object-fit_cover_center">

                        <!-- Project Preview -->
                        <template v-if="['svg', 'html'].indexOf(event._edit.media.preview.type) >= 0">
                          <iframe :id="`mediaEventProjectFile_${event._edit.uid}`"
                            :src="$utils.filterMediaPreviewUrl(event._edit.media.preview.url, { queryParams: { dir: scheduleItemOrig.dir } })"
                            :data-src="$utils.trimDataSrc(event._edit.media.preview.url, { queryParams: { dir: scheduleItemOrig.dir } })"
                            :class="['object-fit_cover_center', 'template-target-on-refresh-token', 'media-project-file', `media-preview-${event._edit.uid}`]">
                          </iframe>
                        </template>
                      </template>

                      <!-- No Preview -->
                      <template v-if="!event._edit.media.hasOwnProperty('preview') || event._edit.media.preview === null">
                        <div class="no-preview">
                          <div class="np-content">
                            <el-icon class="icon"><PictureFilled /></el-icon>
                            {{$t('label.previewUnavailable')}}
                          </div>
                        </div>
                      </template>
                    </div>

                    <div :style="{'backgroundColor': '#5a6781'}" class="media-preview-background"></div>

                  </div>

                  <!-- Media Name -->
                  <div class="media-name">
                    {{`${event._edit.title}`}}

                    <!-- For development only -->
                    <span v-if="$currentUser.hasGroupDebug()"
                      class="dev-row-refrence-debug" :class="{'selected': (event._edit.isRowSelected), 'duplicate-order': (event._edit.hasDuplicateOrder)}">
                      <i class="uid">{{`${event.uid}`}}</i>
                      <i class="order">{{event.order}}</i>
                    </span>
                  </div>
                </div>

                <!--Schedule Times list -->
                <div class="times time-slider-control-sync">
                  <div class="times-content">
                    <div v-for="(time, indx) in event.times" :key="indx"
                      :style="time._edit.style"
                      :class="['time-item', {'is-selected': time._edit.isSelected, 'priority-time': time._edit.showPriorityIcon, 'off-time': time.offTime}]">
                      <div :class="['txt-label', {'no-txt': !time._edit.textLabel.length}]">
                        <div class="priority-icon"></div>
                        {{time._edit.textLabel}}
                      </div>

                      <!-- Time List Background-->
                      <div v-if="scheduleItemOrig._isInErrorStatus || event.lock" class="time-item-background disabled"></div>
                      <div v-else :style="{'backgroundColor': event._edit.mediaRowBackgroundColor}" class="time-item-background"></div>
                    </div>
                  </div>
                </div>

                <div v-if="scheduleItemOrig._isInErrorStatus || event.lock" class="media-row-background disabled"></div>
                <div v-else :style="{'backgroundColor': event._edit.mediaRowBackgroundColor}" class="media-row-background"></div>

                <!-- Event Row Actions -->
                <div v-if="(scheduleItemOrig._isInErrorStatus && scheduleItemOrig._allowOfflineModeToEditMedia) || (!scheduleItemOrig._isInErrorStatus)" class="media-actions">
                  <!-- Duplicate and Edit Schedule playtime should not be visible in event row multple selection -->
                  <el-tooltip
                    v-if="enableEditProject && !event.lock && (event._edit.media.type === 'project' || event._edit.media.type === 'audio-playlist')"
                    :key="`editProjectAddsEventsTooltip-${indx}`"
                    :popper-class="'custom-tooltip-popper-filters text-transform-initial'"
                    :show-arrow="false"
                    effect="light"
                    class="item"
                    :content="$t('label.editProject')"
                    placement="bottom">
                    <el-button
                      :class="['cstm-icon-btn-medium edit', {'hidden': (selectedEventItemRow.eventRows.length > 1)}]"
                      @click="handleMediaEventRowClick(mediaEventRowActionOptions.editMediaProject, event, indx, $event)">
                    </el-button>
                  </el-tooltip>

                  <!-- Duplicate Media Schedule -->
                  <el-tooltip
                    v-if="enableDuplicateSchedule && !event.skin && !event.lock"
                    :key="`duplicateAddsEventsTooltip-${indx}`"
                    :popper-class="'custom-tooltip-popper-filters text-transform-initial'"
                    :show-arrow="false"
                    effect="light"
                    class="item"
                    :content="$t('label.duplicateInSchedule')"
                    placement="bottom">
                    <el-button :class="{'cstm-icon-btn-medium copy': true,
                      'hidden': (selectedEventItemRow.eventRows.length > 1),
                      'is-selected': (event._edit.mediaAction && event._edit.mediaAction === mediaEventRowActionOptions.duplicateMediaSchedule)}"
                      @click="handleMediaEventRowClick(mediaEventRowActionOptions.duplicateMediaSchedule, event, indx, $event)">
                    </el-button>
                  </el-tooltip>

                  <!-- Edit Media Schedule -->
                  <el-tooltip
                    v-if="enableEditCalendar && !event.lock"
                    :key="`editMediaScheduleAddsEventsTooltip-${indx}`"
                    :popper-class="'custom-tooltip-popper-filters text-transform-initial'"
                    :show-arrow="false"
                    effect="light"
                    class="item"
                    :content="$t('label.playTime')"
                    placement="bottom">
                    <el-button :class="{'cstm-icon-btn-medium time': true,
                      'hidden': false,
                      'is-selected': (event._edit.mediaAction && event._edit.mediaAction === mediaEventRowActionOptions.editMediaSchedule)}"
                      @click="handleMediaEventRowClick(mediaEventRowActionOptions.editMediaSchedule, event, indx, $event)">
                    </el-button>
                  </el-tooltip>

                  <!-- Delete Media Schedule -->
                  <el-tooltip
                    v-if="enableEditCalendar && !event.lock"
                    :key="`deleteMediaScheduleAddsEventsTooltip-${indx}`"
                    :popper-class="'custom-tooltip-popper-filters text-transform-initial'"
                    :show-arrow="false"
                    effect="light"
                    class="item"
                    :content="$t('label.deleteFromSchedule')"
                    placement="bottom">
                    <el-button :class="{'cstm-icon-btn-medium remove': true,
                      'is-parent-row-selected': (event._edit.isRowSelected),
                      'is-selected': (event._edit.mediaAction && event._edit.mediaAction === mediaEventRowActionOptions.deletePlaytimeRow),
                      'hover-all-remove-icon-from-selected-row': (event._edit.isRowSelected && hoverAllRemoveIconOnSelectedMedia)}"
                      @click="handleMediaEventRowClick(mediaEventRowActionOptions.deletePlaytimeRow, event, indx, $event)">
                    </el-button>
                  </el-tooltip>

                  <!-- Lock Media Icon -->
                  <el-button
                    v-if="enableEditCalendar && event.lock"
                    :class="{
                      'cstm-icon-btn-medium lock': true,
                      'is-parent-row-selected': (event._edit.isRowSelected),
                      'is-selected': (event._edit.mediaAction && event._edit.mediaAction === mediaEventRowActionOptions.deletePlaytimeRow),
                      'hover-all-remove-icon-from-selected-row': (event._edit.isRowSelected && hoverAllRemoveIconOnSelectedMedia)
                    }">
                  </el-button>
                </div>

                <!-- Event Row Player Tags -->
                <div v-if="((!scheduleItemOrig._isInErrorStatus) || (scheduleItemOrig._isInErrorStatus && scheduleItemOrig._allowOfflineModeToEditMedia))" class="event-row-tags">
                  <template v-if="event.tag">
                    <el-tag
                      :key="`event-tag-${event.tag}`"
                      :closable="false"
                      :disable-transitions="true"
                      :style="{'backgroundColor': (event.tag === 'SMART SYNC') ? $utils.getBackgroundColor({ indx: 1 }) : '#36425c'}"
                      :class="['event-tag']">
                      <div class="tag-val">
                        <span v-if="event.tag.startsWith('tag-')">{{event.tag.substring(4)}}</span>
                        <span v-else>{{event.tag}}</span>
                      </div>
                    </el-tag>
                  </template>

                  <!-- Duration -->
                  <el-tag
                    v-if="!event.skin && (!event._edit.optimisticUpdate || (event._edit.optimisticUpdate && (event._edit.optimisticUpdate.uploadFinished && event._edit.optimisticUpdate.schedulePlaytimeAdded)))"
                    :key="`event-duration-as-tag-${indx}`"
                    :closable="false"
                    :disable-transitions="true"
                    :style="{'backgroundColor': 'rgba(255, 0, 0, 0)'}"
                    :class="['event-duration-time-tag']">
                    <div class="duration-tag-val"><span>{{caculateMediaDuration(event._edit.media)}}</span></div>
                  </el-tag>
                </div>

                <!-- Adds period  -->
                <div class="adds-period">
                  <template
                    v-for="(period, periodIdex) in addsEventsDotsOptions" :key="periodIdex">
                    <div
                      @click="handleSmartAddsRepeatClick(mediaEventRowActionOptions.updateSmartAddsPeriod, event, indx, period.value, $event)"
                      :class="['period', `period-${period.value}`, {'selected': period.value <= event.adds.repeat}]"></div>
                  </template>
                </div>

                <!-- Adds sponsored action -->
                <div :class="['adds-sponsored-action', {'enabled' : event._edit.addsSponsoredTextEnabled}]"
                  @click="handleSmartAddsSponsoredActionClick(mediaEventRowActionOptions.updateSmartAddsSponsored, event, indx, $event)">
                </div>

                <!-- Row Cover -->
                <draggable
                  v-if="(!scheduleItemOrig._isInErrorStatus) || (scheduleItemOrig._isInErrorStatus && scheduleItemOrig._allowOfflineModeToEditMedia)"
                  v-bind="sortTagsDropzoneOptions"
                  class="media-row-item-cover"
                  tag="div"
                  item-key="uid"
                  ghost-class="tag-sortable-ghost"
                  :id="event.uid"
                  :list="[event]"
                  :disabled="isSortingScheduleItem"
                  :group="{ name: 'tags-shared', pull: false, put: true }"
                  :component-data="{
                    onClick: (e) => handleMediaEventRowClick(mediaEventRowActionOptions.scheduleEventRowSelected, event, indx, e)
                  }"
                  @add="handleTagDraggableAdd($event, event)"
                >
                  <template #item="{ element: eventItem, index: index }">
                    <div
                      class="media-preview-cover"
                      @click="handleMediaEventPreviewClick(mediaEventRowActionOptions.handleRegularScheduleMediaEventPreviewSelected, eventItem, index, $event)">
                    </div>
                  </template>
                </draggable>
                <!-- <div v-if="(!scheduleItemOrig._isInErrorStatus) || (scheduleItemOrig._isInErrorStatus && scheduleItemOrig._allowOfflineModeToEditMedia)"
                  class="media-row-item-cover"
                  @click="handleMediaEventRowClick(mediaEventRowActionOptions.scheduleEventRowSelected, event, indx, $event)">
                  <div @click="handleMediaEventPreviewClick(mediaEventRowActionOptions.handleRegularScheduleMediaEventPreviewSelected, event, indx, $event)"
                    class="media-preview-cover"></div>
                </div> -->

                <!-- Proof of Play Identifier -->
                <div v-if="showPopIds" class="pop-identifier-display">
                  <div class="base">
                    <div class="text">{{event._edit.popIdDisplay}}</div>
                  </div>
                  <div class="pop-icon"></div>

                  <div class="pop-identifier-item-cover"
                    @mouseover="handlePopIdHover($event, 'mouseover')"
                    @mouseout="handlePopIdHover($event, 'mouseout')">
                  </div>
                </div>
              </div>
            </template>
          </draggable>

          <template v-if="enableEditCalendar">
            <el-button v-if="(!scheduleItemOrig._isInErrorStatus) || (scheduleItemOrig._isInErrorStatus && scheduleItemOrig._allowOfflineModeToEditMedia)"
              @click="handleAddMediaClick({smartAdds: true})" class="cstm-icon-btn-medium add add-new-media-smart-adds"></el-button>
          </template>
        </div>
      </template>

      <!-- Media Events -->
      <template v-if="scheduleItemFullDetails !== null">
        <div id="regularScheduleSortGroupWrapper">
          <draggable
            v-bind="sortDraggableOptions"
            v-model="scheduleItemFullDetails.events"
            id="mediaEventsSortGroup"
            group="regular-schedule-sort"
            :item-key="(element) => element?._edit?.sortKeyWithIndx"
            :component-data="{name:'flip-list'}"
            :disabled="!enableEditCalendar || lockDraggableSortableEventRow === 'regularScheduleSortable'"
            :class="{'media-events-sortable-group': true, 'disabled': !enableEditCalendar}"
            :forceFallback="true"
            :move="handleMediaEventSortMove"
            @clone="handleMediaEventSortClone({regularSchedule: true})"
            @start="handleMediaEventSortStart"
            @end="handleMediaEventSortEnd">

            <template #item="{ element: event, index: indx }">
              <div
                :class="['media-row-item', 'sortable-el', 'list-group-item', 'regular-schedule-row', `eventUid${event.uid}`,
                { 'media-uploading': event._edit && (event._edit.optimisticUpdate && !event._edit.optimisticUpdate.uploadFinished),
                'sorting': sortingRequests.find((req) => req.order === event.order),
                'select-none': true,
                'is-selected': (event._edit.isSelected),
                'is-row-selected': (event._edit.isRowSelected),
                'is-sort-drag': mediaEventSortDragTriggered.start,
                'mouseover': (mouseoverMediaItemClass === `eventUid${event.uid}`),
                'disabled-mouseover': (disableMouseoverClass === `eventUid${event.uid}`),
                'has-pop-identifer': (event._edit.popId && showPopIds) }]"
                @mouseover="handleMediaRowMouseHoverAndMouseOut('mouseover', $event)"
                @mouseout="handleMediaRowMouseHoverAndMouseOut('mouseout', $event)">

                <!--Schedule Details -->
                <div :class="['media-details']">
                  <div class="media-preview-wrapper grey-background">
                    <div class="media-preview"
                      :style="{backgroundColor: event._edit.mediaRowBackgroundColorFade, ...scheduleItemOrig._edit.mediaPreviewCardStyle}">
                      <template v-if="event._edit.media.hasOwnProperty('preview') && event._edit.media.preview !== null">
                        <!-- Image Preview -->
                        <img v-if="event._edit.media.preview.type === 'img'"
                          :src="$utils.filterMediaPreviewUrl(event._edit.media.preview.url)"
                          class="object-fit_cover_center">

                        <!-- Project Preview -->
                        <template v-if="['svg', 'html'].indexOf(event._edit.media.preview.type) >= 0">
                          <iframe :id="`mediaEventProjectFile_${event._edit.uid}`"
                            :src="$utils.filterMediaPreviewUrl(event._edit.media.preview.url, { queryParams: { dir: scheduleItemOrig.dir } })"
                            :data-src="$utils.trimDataSrc(event._edit.media.preview.url, { queryParams: { dir: scheduleItemOrig.dir } })"
                            :class="['object-fit_cover_center', 'template-target-on-refresh-token', 'media-project-file', `media-preview-${event._edit.uid}`]">
                          </iframe>
                        </template>
                      </template>

                      <!-- No Preview -->
                      <template v-if="!event._edit.media.hasOwnProperty('preview') || event._edit.media.preview === null">
                        <div class="no-preview">
                          <div class="np-content">
                            <el-icon class="icon"><PictureFilled /></el-icon>
                            {{$t('label.previewUnavailable')}}
                          </div>
                        </div>
                      </template>
                    </div>

                    <div :style="{'backgroundColor': event._edit.mediaRowBackgroundColor}" class="media-preview-background"></div>
                  </div>

                  <!-- Media Name -->
                  <div class="media-name">
                    {{`${event._edit.title}`}}

                    <!-- For development only -->
                    <span v-if="$currentUser.hasGroupDebug()"
                      class="dev-row-refrence-debug" :class="{'selected': (event._edit.isRowSelected), 'duplicate-order': (event._edit.hasDuplicateOrder)}">
                      <i class="uid">{{`${event.uid}`}}</i>
                      <i class="order">{{event.order}}</i>
                    </span>
                  </div>
                </div>

                <!-- Schedule Times list -->
                <div class="times time-slider-control-sync">
                  <div class="times-content">
                    <div v-for="(time, indx) in event.times" :key="indx"
                      :style="time._edit.style"
                      :class="['time-item', {'is-selected': time._edit.isSelected, 'priority-time': time._edit.showPriorityIcon, 'off-time': time.offTime}]">
                      <div :class="['txt-label', {'no-txt': !time._edit.textLabel.length}]">
                        <div class="priority-icon"></div>
                        {{time._edit.textLabel}}
                      </div>

                      <!-- Time List Background-->
                      <div v-if="scheduleItemOrig._isInErrorStatus || event.lock" class="time-item-background disabled"></div>
                      <div v-else :style="{'backgroundColor': event._edit.mediaRowBackgroundColor}" class="time-item-background"></div>
                    </div>
                  </div>
                </div>

                <div v-if="scheduleItemOrig._isInErrorStatus || event.lock" class="media-row-background disabled"></div>
                <div v-else :style="{'backgroundColor': event._edit.mediaRowBackgroundColor}" class="media-row-background"></div>

                <!-- Event Row Actions -->
                <div v-if="(scheduleItemOrig._isInErrorStatus && scheduleItemOrig._allowOfflineModeToEditMedia) || (!scheduleItemOrig._isInErrorStatus)" class="media-actions">
                  <!-- Duplicate and Edit Schedule playtime should not be visible in event row multple selection -->
                  <el-tooltip
                    v-if="enableEditProject && !event.lock && (event._edit.media.type === 'project' || event._edit.media.type === 'audio-playlist')"
                    :key="`editProjectEventsTooltip-${indx}`"
                    :popper-class="'custom-tooltip-popper-filters text-transform-initial'"
                    :show-arrow="false"
                    effect="light"
                    class="item"
                    :content="$t('label.editProject')"
                    placement="bottom">
                    <el-button
                      :class="['cstm-icon-btn-medium edit', {'hidden': (selectedEventItemRow.eventRows.length > 1)}]"
                      @click="handleMediaEventRowClick(mediaEventRowActionOptions.editMediaProject, event, indx, $event)">
                    </el-button>
                  </el-tooltip>

                  <!-- Duplicate Media Schedule -->
                  <el-tooltip
                    v-if="enableDuplicateSchedule && !event.skin && !event.lock"
                    :key="`duplicateEventsTooltip-${indx}`"
                    :popper-class="'custom-tooltip-popper-filters text-transform-initial'"
                    :show-arrow="false"
                    effect="light"
                    class="item"
                    :content="$t('label.duplicateInSchedule')"
                    placement="bottom">
                    <el-button :class="{'cstm-icon-btn-medium copy': true,
                      'hidden': (selectedEventItemRow.eventRows.length > 1),
                      'is-selected': (event._edit.mediaAction && event._edit.mediaAction === mediaEventRowActionOptions.duplicateMediaSchedule)}"
                      @click="handleMediaEventRowClick(mediaEventRowActionOptions.duplicateMediaSchedule, event, indx, $event)">
                    </el-button>
                  </el-tooltip>

                  <!-- Edit Media Schedule -->
                  <el-tooltip
                    v-if="enableEditCalendar && !event.lock"
                    :key="`editMediaScheduleAddsTooltip-${indx}`"
                    :popper-class="'custom-tooltip-popper-filters text-transform-initial'"
                    :show-arrow="false"
                    effect="light"
                    class="item"
                    :content="$t('label.playTime')"
                    placement="bottom">
                    <el-button :class="{'cstm-icon-btn-medium time': true,
                      'hidden': false,
                      'is-selected': (event._edit.mediaAction && event._edit.mediaAction === mediaEventRowActionOptions.editMediaSchedule)}"
                      @click="handleMediaEventRowClick(mediaEventRowActionOptions.editMediaSchedule, event, indx, $event)">
                    </el-button>
                  </el-tooltip>

                  <!-- Delete Media Schedule -->
                  <el-tooltip
                    v-if="enableEditCalendar && !event.lock"
                    :key="`deleteMediaScheduleEventsTooltip-${indx}`"
                    :popper-class="'custom-tooltip-popper-filters text-transform-initial'"
                    :show-arrow="false"
                    effect="light"
                    class="item"
                    :content="$t('label.deleteFromSchedule')"
                    placement="bottom">
                    <el-button  :class="{'cstm-icon-btn-medium remove': true,
                      'is-parent-row-selected': (event._edit.isRowSelected),
                      'is-selected': (event._edit.mediaAction && event._edit.mediaAction === mediaEventRowActionOptions.deletePlaytimeRow),
                      'hover-all-remove-icon-from-selected-row': (event._edit.isRowSelected && hoverAllRemoveIconOnSelectedMedia)}"
                      @click="handleMediaEventRowClick(mediaEventRowActionOptions.deletePlaytimeRow, event, indx, $event)">
                    </el-button>
                  </el-tooltip>

                  <!-- Lock Media Icon -->
                  <el-button v-if="enableEditCalendar && event.lock" :class="{'cstm-icon-btn-medium lock': true,
                    'is-parent-row-selected': (event._edit.isRowSelected),
                    'is-selected': (event._edit.mediaAction && event._edit.mediaAction === mediaEventRowActionOptions.deletePlaytimeRow),
                    'hover-all-remove-icon-from-selected-row': (event._edit.isRowSelected && hoverAllRemoveIconOnSelectedMedia)}">
                  </el-button>
                </div>

                <!-- Event Row Player Tags -->
                <div v-if="((!scheduleItemOrig._isInErrorStatus) || (scheduleItemOrig._isInErrorStatus && scheduleItemOrig._allowOfflineModeToEditMedia))" class="event-row-tags">
                  <template v-if="event.tag">
                    <el-tag
                      :key="`event-tag-${event.tag}`"
                      :closable="false"
                      :disable-transitions="true"
                      :style="{'backgroundColor': (event.tag === 'SMART SYNC') ? $utils.getBackgroundColor({ indx: 1 }) : getEventRowTagBackgroundColor({tag: event.tag , position: indx })}"
                      :class="['event-tag']">
                      <div class="tag-val">
                        <span v-if="event.tag.startsWith('tag-')">{{event.tag.substring(4)}}</span>
                        <span v-else>{{event.tag}}</span>
                      </div>
                    </el-tag>
                  </template>

                  <!-- Duration -->
                  <el-tag
                    v-if="!event.skin && (!event._edit.optimisticUpdate || (event._edit.optimisticUpdate && event._edit.optimisticUpdate.uploadFinished))"
                    :key="`event-duration-as-tag-${indx}`"
                    :closable="false"
                    :disable-transitions="true"
                    :style="{'backgroundColor': 'rgba(255, 0, 0, 0)'}"
                    :class="['event-duration-time-tag']">
                    <div class="duration-tag-val"><span>{{ caculateMediaDuration(event._edit.media) }}</span></div>
                  </el-tag>
                </div>

                <!-- Proof of Play Identifier -->
                <div v-if="showPopIds" class="pop-identifier-display">
                  <div class="base">
                    <div class="text">{{event._edit.popIdDisplay}}</div>
                  </div>
                  <div class="pop-icon"></div>

                  <div class="pop-identifier-item-cover"
                    @mouseover="handlePopIdHover($event, 'mouseover')"
                    @mouseout="handlePopIdHover($event, 'mouseout')">
                  </div>
                </div>

                <draggable
                  v-if="(!scheduleItemOrig._isInErrorStatus) || (scheduleItemOrig._isInErrorStatus && scheduleItemOrig._allowOfflineModeToEditMedia)"
                  v-bind="sortTagsDropzoneOptions"
                  class="media-row-item-cover"
                  tag="div"
                  item-key="uid"
                  ghost-class="tag-sortable-ghost"
                  :id="event.uid"
                  :list="[event]"
                  :disabled="isSortingScheduleItem"
                  :group="{ name: 'tags-shared', pull: false, put: true }"
                  :component-data="{
                    onClick: (e) => handleMediaEventRowClick(mediaEventRowActionOptions.scheduleEventRowSelected, event, indx, e)
                  }"
                  @add="handleTagDraggableAdd($event, event)"
                >
                  <template #item="{ element: eventItem, index: index }">
                    <div
                      class="media-preview-cover"
                      @click="handleMediaEventPreviewClick(mediaEventRowActionOptions.handleRegularScheduleMediaEventPreviewSelected, eventItem, index, $event)">
                    </div>
                  </template>
                </draggable>
                <!-- <div v-if="(!scheduleItemOrig._isInErrorStatus) || (scheduleItemOrig._isInErrorStatus && scheduleItemOrig._allowOfflineModeToEditMedia)"
                  class="media-row-item-cover"
                  @click="handleMediaEventRowClick(mediaEventRowActionOptions.scheduleEventRowSelected, event, indx, $event)">
                  <div @click="handleMediaEventPreviewClick(mediaEventRowActionOptions.handleRegularScheduleMediaEventPreviewSelected, event, indx, $event)" class="media-preview-cover"></div>
                </div> -->
              </div>
            </template>
          </draggable>

          <template v-if="enableEditCalendar">
            <el-button v-if="(!scheduleItemOrig._isInErrorStatus) || (scheduleItemOrig._isInErrorStatus && scheduleItemOrig._allowOfflineModeToEditMedia)" @click="handleAddMediaClick" class="cstm-icon-btn-medium add add-new-media"></el-button>
          </template>
        </div>
      </template>

      <el-button v-if="(scheduleItemFullDetails && scheduleItemFullDetails.events.length) && ($currentUser.hasGroupDevelopment())"
        @click="handleSelectAllEventRow"
        :class="['cstm-btn-grey width-125 select-all-events white-background', {}]">{{$t('label.selectAll')}}
      </el-button>
    </div>

    <!-- Media List Dialog -->
    <div class="cstm-modal-media-list">
      <el-dialog
        id="mediaDialogInSchedulePage"
        :z-index="999"
        :model-value="mediaListDialog.isVisible"
        :close-on-click-modal="false"
        :class="['cstm-modal-media-list', 'schedule-media-list', { 'vertical': scheduleItemOrig.dir === 'vertical' }]"
        :append-to-body="false"
        :modal="false"
        @close="handleDialogClose">
        <media-list
          :accessorComponentProp="'scheduleEventItem'"
          :defaultMediaTypeFilterProp="mediaListDialog.filterType"
          :mediaSelectionProp="mediaListDialog.mediaSelection"
          :mediaTypeOptionsProp="mediaListDialog.filterTypeOptions"
          :mediaItemToHideProp="[]"
          :additionalMediaFilterTypeProp="additionalMediaFilterTypeInAddMedia"
          :isMediaListVisibleProp="mediaListDialog.isVisible"
          :isMultipleUploadProp="true"
          :showProjectFilterOptionProp="true"
          :tagSliderledTagItemProp="mediaListTagSliderLedTagItem"
          :forSmartAddsProp="mediaListDialog.addTo === mediaListDialog.addToOptions.smartAddsSchedule"
          :playerFeaturesProp="scheduleItemFullDetails ? scheduleItemFullDetails.features : []"
          @media-list-change="handleAddNewMediaFromMediaListModal($event, 'media-list-modal')">
        </media-list>
      </el-dialog>
    </div>
  </div>
</template>

<script src="./selected-schedule-item.js"></script>
<style lang="scss" src="./selected-schedule-item.scss"></style>
